import { httpClient } from "../../shared/configs/http-client";
import {
  GetCampaignsPayload,
  GetCampaignsResponse,
  CreateCampaignPayload,
  CreateCampaignResponse,
  CampaignDetails,
} from "./types";

const getList = async (params: GetCampaignsPayload) => {
  const { data } = await httpClient.get<GetCampaignsResponse>(
    "/campaigns/list",
    {
      params,
    }
  );

  return data;
};

const getById = async (id: number) => {
  const { data } = await httpClient.get<CampaignDetails>(`/campaigns/${id}`);

  return data;
};

const createCampaign = async (payload: CreateCampaignPayload) => {
  const { data } = await httpClient.post<CreateCampaignResponse>(
    "/campaigns/create",
    {
      name: payload.name,
      category: payload.category,
      articles: payload.articles.map((article) => ({
        url: article.url,
        date: article.date ? new Date(article.date).toISOString() : undefined,
        skipCutLongSentences: article.skipCutLongSentences,
      })),
    }
  );

  return data;
};

const deleteCampaignById = async (id: number) => {
  const { data } = await httpClient.delete<{ id: number }>(`/campaigns/${id}`);

  return data;
};

export const campaignsApi = {
  getList,
  getById,
  deleteCampaignById,
  createCampaign,
};
